<script>
  import { updateState, requestInboxUpdate } from './appUpdates.js';
</script>

{#if $updateState.available || $updateState.busy || $updateState.failed}
  <section class="update" role="status" aria-label="Programėlės atnaujinimas">
    {#if $updateState.busy}
      <p>Tikrinami atverti langai. Trumpam pristabdyta redagavimo galimybė; žinutės nebus siunčiamos.</p>
    {:else if $updateState.failed}
      <p>Programėlė neatnaujinta. Patikrinkite neišsaugotus juodraščius, neaiškias užklausas ir telefono nuostatas.
        Užbaikite darbus kituose Tutory languose ir juos užverkite, tada bandykite dar kartą. Nieko automatiškai nekartosime.</p>
    {:else}
      <p>Yra nauja programėlės versija. Atnaujinsime tik tada, kai visi atverti langai bus pasiruošę.</p>
    {/if}
    {#if $updateState.available}
      <button type="button" disabled={$updateState.busy} on:click={requestInboxUpdate}>Saugiai atnaujinti</button>
    {/if}
  </section>
{/if}

<style>
  .update { padding: .65rem 1rem; border-bottom: 1px solid #d3b39e; background: #fff4e9; color: #38332e; font-size: .85rem; }
  p { margin: 0 0 .4rem; }
  button { min-height: 44px; padding: .5rem .75rem; font: inherit; color: #9c3800; background: white; border: 1px solid #bdb4aa; border-radius: .35rem; cursor: pointer; }
  button:disabled { opacity: .55; cursor: default; }
  button:focus-visible { outline: 3px solid #c84b09; outline-offset: 3px; }
</style>
